import {BindingExpiration} from 'api/gen/BindingExpiration';

import styles from '../components/global-management-styles.sass';

/**
 * Maps binding expiration state to a CSS class name.
 *
 * @param expiration Binding expiration state.
 * @returns CSS class name for the expiration state, or `undefined`.
 */
export const getExpirationColor = (expiration: BindingExpiration): string | undefined => {
    if (expiration === 'EXPIRES_TODAY') return styles.endsToday;
    if (expiration === 'EXPIRES_LESS_THAN_30_DAYS') return styles.endsInMonth;

    return undefined;
};
